export function isColoradoBranch(branchCode: string) {
  const coloradoBranches = ["1401", "1402", "1403", "1404", "1405", "7039"];
  return coloradoBranches.includes(branchCode);
}
